import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer>
            <div className="subfooter">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="de-flex">
                                <div className="de-flex-col">
                                    <span className="copy">&copy; Copyright 2022</span>
                                </div>
                                <div className="de-flex-col">
                                    <div className="social-icons">
                                        <Link to="/">
                                            <i className="fa fa-facebook fa-lg"></i>
                                        </Link>
                                        <Link to="/">
                                            <i className="fa fa-twitter fa-lg"></i>
                                        </Link>
                                        <Link to="/">
                                            <i className="fa fa-linkedin fa-lg"></i>
                                        </Link>
                                        <Link to="/">
                                            <i className="fa fa-pinterest fa-lg"></i>
                                        </Link>
                                        <Link to="/">
                                            <i className="fa fa-rss fa-lg"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
